import { Col } from "reactstrap";
import { UL } from "../../../AbstractElements";
// import DarkMode from "./DarkMode/DarkMode";
// import HeaderMessage from "./HeaderMessage/HeaderMessage";
// import Language from "./Language/Language";
import Notifications from "./Notifications/Notifications";
import UserProfile from "./UserProfile/UserProfile";
import ZoomInOut from "./ZoomInOut/ZoomInOut";

const RightHeader = () => {
  return (
    <Col
      xxl="8"
      xl="6"
      md="7"
      xs="8"
      className="nav-right pull-right right-header p-0 ms-auto"
    >
      <UL className="nav-menus flex-row simple-list">
        <ZoomInOut />
        {/* <Notifications />Mofi theme by pixelstrap */}
        {/* <DarkMode /> */}
        {/* <HeaderMessage /> */}
        {/* <Language /> */}
        <UserProfile />
      </UL>
    </Col>
  );
};

export default RightHeader;
